import { gql } from '@apollo/client';
import { promotionDetails } from './fetch-available-promotions-for-entitlement';

export const fetchAvailablePartnerPromotionsForEntitlement = gql`
  ${promotionDetails}
  query fetchAvailablePartnerPromotionsForEntitlement(
    $id: String
    $intendedBillingPeriodState: String
    $billingFrequency: String
    $discountTier: String
    $programLevelGlobal: String
  ) {
    entitlementDetails(id: $id) {
      id
      subscriptionId
      billingFrequency: billingCycle
      productId
      edition
      availablePartnerPromotions(
        intendedBillingPeriodState: $intendedBillingPeriodState
        billingFrequency: $billingFrequency
        discountTier: $discountTier
        programLevelGlobal: $programLevelGlobal
      ) {
        ...promotionDetails
      }
    }
  }
`;
